<div
    *ngIf="isEditing"
    class="agpr-textareaInput"
    [class.agpr-textareaInput--spaced]="bottomMargin"
    [ngClass]="{'social': style === componentStyles.social}"
>
    <div class="agpr-textareaInput-container">
        <div class="agpr-textareaInput-inputWrapper">
            <label
                *ngIf="label || required"
                [id]="id + '-label'"
                class="agpr-textareaInput-label"
            >
                {{ label | localize }} <span *ngIf="required" class="agpr-textareaInput-required">*</span>
                <span
                    *ngIf="tooltip"
                    role="img"
                    class="fa-regular fa-circle-info agpr-textareaInput-infoIcon"
                    [agprTooltip]="tooltip | localize"
                    [escape]="false"
                ></span>
            </label>

            @if (hint) {
                <div [id]="id + '_hint'" class="agpr-textareaInput-hint">
                    {{ hint | localize }}
                </div>
            }


            <textarea
                *ngIf="!icon"
                #input
                [id]="id"
                [placeholder]="placeholder | localize"
                [attr.aria-label]="ariaLabel | localize"
                class="agpr-textareaInput-input"
                [class.agpr-textareaInput-no-scrollbar]="autoGrow"
                [attr.maxLength]="maxLength"
                [attr.rows]="rows"
                [ngStyle]="{'resize': resize}"
                [disabled]="disabled"
                [(ngModel)]="value"
                (ngModelChange)="onModelChange(value)"
                (blur)="onBlur($event)"
                (focus)="onFocus($event)"
                (keydown)="keydown.emit($event)"
                (keyup)="autoGrow ? adjustHeight($event) : ''"
                [attr.aria-labelledby]="id + '-label'"
                [attr.aria-describedby]="ariaDescribedBy"
                dir="auto"
                [attr.required]="required ? true : null"
            ></textarea>


            @if (icon || agentic) {
                <div
                    [ngClass]="{'agpr-textareaInput-input-border': agentic}"
                >
                    <div
                        #contentEditableDiv
                        [id]="id"
                        class="agpr-textareaInput-input agpr-textareaInput-contentEditable"
                        [class.agpr-textareaInput-no-scrollbar]="autoGrow"
                        [class.agpr-textareaInput-contentEditable--noResize]="resize === resizeNone"
                        [class.is-empty]="isDomEmpty"
                        [attr.contenteditable]="!disabled ? 'true' : 'false'"
                        [attr.aria-label]="ariaLabel | localize"
                        [attr.aria-labelledby]="id + '-label'"
                        [attr.aria-describedby]="ariaDescribedBy"
                        [attr.data-placeholder]="placeholder | localize"
                        [attr.required]="required ? true : null"
                        [style.resize]="resize"
                        [style.min-height]="contentEditableMinHeight"
                        [style.max-height]="resize === resizeNone ? contentEditableMinHeight : null"
                        tabindex="0"
                        dir="auto"
                        (input)="onContentEditableChange($event)"
                        (click)="onContentEditableClick()"
                        (blur)="onBlur($event)"
                        (focus)="onFocus($event)"
                        (keydown)="onContentEditableKeyDown($event)"
                        (paste)="onContentEditablePaste($event)"
                    ><span contenteditable="false" class="agpr-textareaInput-icon" [ngClass]="icon"></span></div>
                </div>
            }

        </div>
    </div>
</div>
